<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0"></div>
        </form>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                      <div
                        class="media-body ml-2 d-none d-lg-block"
                        v-if="cpd.name"
                      >
                        <i class="ni ni-bell-55"></i>
                        <span class="mb-0 text-sm  font-weight-bold text-capitalize">
                          Notifications
                          <badge type="white" v-if="notifications.total > 0">
                            {{ notifications.total }}
                          </badge>&nbsp;
                        </span>
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </div>

                    <template>
                        <div
                          v-if="notifications && notifications.records && notifications.records.length > 0"
                        >
                          <router-link
                            :to="'/notifications/'+notification.id"
                            class="dropdown-item"
                            v-for="notification in notifications.records"
                            :key="notification.id"
                          >
                            <i class="fa fa-angle-right"></i>
                            <span
                              :class="'notification-size ' +
                                ((notification.status == 'unread') ? 'font-weight-bold' : '')"
                            >
                              {{ truncate(notification.subject) }}
                            </span>
                          </router-link>
                        </div>
                        <div class="dropdown-divider"></div>
                        <router-link to="/notifications" class="dropdown-item">
                            <i class="ni ni-sound-wave"></i>
                            <span>View All</span>
                        </router-link>
                    </template>
                </base-dropdown>
            </li>
        </ul>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                      <span class="avatar avatar-sm rounded-circle">
                        <img
                            :alt="cpd.name"
                            :src="photo"
                            @error="replaceByDefault"
                            class="image-size"
                        >
                      </span>
                      <div
                        class="media-body ml-2 d-none d-lg-block"
                        v-if="cpd && cpd.name"
                      >
                        <span class="mb-0 text-sm  font-weight-bold text-capitalize">
                          {{ cpd.name }}
                        </span>
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </div>

                    <template>
                        <div class=" dropdown-header noti-title" v-if="cpd">
                            <h6 class="text-overflow m-0">
                              Welcome, {{ truncate(cpd.name) }}
                            </h6>
                        </div>

                        <div>
                          <router-link to="/profile"
                            class="dropdown-item"
                          >
                              <i class="ni ni-single-02"></i>
                              <span>My Account</span>
                          </router-link>
                          <router-link to="/change-password"
                            class="dropdown-item"
                          >
                              <i class="ni ni-settings-gear-65"></i>
                              <span>Change Password</span>
                          </router-link>
                          <router-link to="/notifications"
                            class="dropdown-item"
                          >
                              <i class="ni ni-bell-55"></i>
                              <span>Notifications</span>
                          </router-link>
                        </div>
                        <div class="dropdown-divider"></div>
                        <router-link to="/logout" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Logout</span>
                        </router-link>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
  // get user's details from store
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: ''
      };
    },
    computed: {
      ...mapGetters(['cpd', 'blankImageUrl', 'cpdPhotoUrl', 'notifications']),
      photo() {// get MD Passport
        return this.cpd && this.cpd.photo && this.cpd.photo.image ? this.cpd.photo.image : this.blankImageUrl;
      }
    },
    methods: {
      truncate: function (text) {
        if (text && text.length > 20) {
          return text.substring(0, 30) + '...'
        } else {
          return text
        }
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      ...mapActions(['getCpdNotifications']),
      replaceByDefault(e) {
        return e.target.src = this.blankImageUrl;
      }
    },
    mounted() {
      this.getCpdNotifications(5);
    }
  };
</script>

<style scoped>
  .image-size {
    width: 40px;
    height: 40px;
  }
  .notification-size {
    font-size: 12px;
  }
</style>
